import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Megamenu } from '@interfaces/megamenu';
import { NestedLink } from '@interfaces/nested-link';
import { RouterLink } from '@angular/router';
import { NgFor, NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'app-header-megamenu',
    templateUrl: './megamenu.component.html',
    styleUrls: ['./megamenu.component.scss'],
    standalone: true,
    imports: [NgFor, NgClass, NgIf, RouterLink]
})
export class MegamenuComponent {
    @Input() menu: Megamenu;

    @Output() itemClick: EventEmitter<NestedLink> = new EventEmitter<NestedLink>();

    constructor() { }
}
